<template>
  <section class="content checkout-content wp_AllPageMarginTop">
    <div class="row">
      <div class="col-0 col-lg-2 d-none d-lg-block">
        <ul class="list-group">
          <div
            v-for="(user,index) in routes"
            :key=user.name
            @click="userRoute(user.to)"
            style="cursor: pointer"
          >
            <li
              class="list-group-item list-group-item-action"
              :id="'user-name-items'+index"
														:data-test="'UserNameList'+index"
            >
              <router-link
                class="nav-link"
                :to=user.to
                :id="'user-name-'+index"
																:data-test="'UserName'+index"
              >
                {{user.name}}
              </router-link>
            </li>
          </div>
        </ul>
      </div>
      <router-view>
      </router-view>
    </div>
  </section>
</template>
<script>

export default {
	mounted () {
		this.activeLink = document.querySelector('.router-link-active')
	},
	watch: {
		activeLink () {
			const parentElement = this.activeLink.parentElement
			if (parentElement.nodeName.toLowerCase() === 'li') {
				parentElement.classList.add('active')
			}
		}
	},
	data () {
		return {
			routes: [
				{
					name: 'Profile',
					to: {
						path: '/user/profile',
						query: {
							display_text: 'My Profile'
						}
					}
				},
				{
					name: 'Orders',
					to: {
						path: '/user/orders',
						query: {
							display_text: 'My Orders'
						}
					}
				},
				{
					name: 'Wishlist',
					to: {
						path: '/user/wish-list',
						query: {
							display_text: 'My Wishlist'
						}
					}
				},
				{
					name: 'Addresses',
					to: {
						path: '/user/addresses',
						query: {
							display_text: 'My Addresses'
						}
					}
				},
				{
					name: 'Gift Card',
					to: {
						path: '/user/giftCards',
						query: {
							display_text: 'Gift Cards'
						}
					}
				}
				// {
				//   name: 'SavedCards',
				//   to: '/user/saved-cards',
				// },
			],
			activeLink: ''
		}
	},
	methods: {
		userRoute (to) {
			this.$router.push(to)
		}
	}
}
</script>
